import { ReactNode } from 'react';

import CssBaseline from '@material-ui/core/CssBaseline';
import ThemeProvider from '@material-ui/styles/ThemeProvider';

import { legacyTheme, theme } from './themes';

type CollegeHunksThemeProps = {
  children: ReactNode;
  keepLegacy?: boolean;
};

export const CollegeHunksTheme = ({ children, keepLegacy }: CollegeHunksThemeProps) => {
  return (
    <ThemeProvider theme={keepLegacy ? legacyTheme : theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};
